import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["permissions"]),
  },
  methods: {
    /**
     * Checks if the user can manually fund a budget
     * @param {Object} destinationBudget - The budget object to check
     * @returns {Boolean} - True if the user can manually fund the budget
     */
    checkCanManuallyFundBudget(destinationBudget) {
      // Baseline check to see if the budget is valid
      if (!destinationBudget || !destinationBudget.Award) return false;

      // if the budget is noncash without monetary value, we can manually fund it
      if (destinationBudget.awardId != 1 && !destinationBudget.Award.cashValuePoints) return true;

      // Otherwise we check if the user has the permission to manually fund the budget
      return (
        this.isBudgetOwner(destinationBudget) &&
        this.permissions.includes("wallets:manualfund:budget") &&
        (destinationBudget.awardId == 1 || destinationBudget.Award.cashValuePoints)
      );
    },
    /**
     * Checks if the user is an owner of the budget
     * @param {Object} budget - The budget object to check
     * @returns {Boolean} - True if the user is an owner of the budget
     */
    isBudgetOwner(budget) {
      return !!(budget && budget.permissions && budget.permissions.owner);
    },
    /**
     * Checks if the budget has funding options that would appear in StripePaymentMethodsManager
     * @param {Object} budget - The budget object to check
     * @returns {Boolean} - True if the budget has funding options that would appear in StripePaymentMethodsManager
     */
    hasBudgetFundingOptions(budget) {
      return (
        budget &&
        this.isBudgetOwner(budget) &&
        // They will either see the Stripe options or the manual funding option
        (budget.awardId == 1 || this.checkCanManuallyFundBudget(budget))
      );
    },
  },
};
